export default "__VITE_ASSET__UJY3_25u__";